import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as VmsState from '../../backend/index-vms-state';

import { LookerDashboardView } from '../../components';
import s from './SpatialInsights.module.scss';

/*
 * Spatial Insights (PBI 1610410): the Looker counterpart of Visitor Insights.
 * The route thunk stores a freshly signed, venue-scoped embed URL in session
 * state before this view mounts; the iframe renders it directly. If the embed
 * session expires mid-visit we clear it and ask the user to reopen the page
 * (re-entering re-requests a fresh signed URL).
 */
class SpatialInsights extends Component {
    static propTypes = {
        embedUrl: PropTypes.string,
        expired: PropTypes.bool,
        error: PropTypes.string,
        dispatch: PropTypes.func,
    };

    static defaultProps = {
        embedUrl: '',
        expired: false,
        error: undefined,
    };

    onSessionExpired = () => {
        const { dispatch } = this.props;
        dispatch(VmsState.SessionReducer.Actions.setLookerEmbed({ expired: true }));
    };

    render() {
        const { embedUrl, expired, error } = this.props;
        if (expired) {
            return (
                <div className={s.spatialInsights} data-testid='spatial-insights'>
                    <div className={s.message} data-testid='looker-expired'>
                        {'Your Spatial Insights session expired. Open Spatial Insights again to refresh.'}
                    </div>
                </div>
            );
        }
        if (error) {
            const message =
                error === 'forbidden'
                    ? "You don't have access to Spatial Insights. Ask your administrator to grant you access."
                    : 'Spatial Insights is unavailable right now. Try again later.';
            return (
                <div className={s.spatialInsights} data-testid='spatial-insights'>
                    <div className={s.message} data-testid='looker-error'>
                        {message}
                    </div>
                </div>
            );
        }
        return (
            <div className={s.spatialInsights} data-testid='spatial-insights'>
                <LookerDashboardView embedUrl={embedUrl} onSessionExpired={this.onSessionExpired} />
            </div>
        );
    }
}

const mapStateToProps = state => {
    const lookerEmbed = VmsState.SessionReducer.Selectors.getLookerEmbed(state) || {};
    return {
        embedUrl: lookerEmbed.embedUrl,
        expired: !!lookerEmbed.expired,
        error: lookerEmbed.error,
    };
};

export default connect(mapStateToProps)(SpatialInsights);
